import { User } from 'firebase/auth';
import { ref } from 'vue';

export const appUser = ref<User | null>(null);
